/**
 * Comprehensive list of countries that are recognized by EU - in other words,
 * the legal set of countries in the world. Those are the UN members, the Vatican,
 * and Taiwan (Republic of China).
 *
 * Kosovo is not recognized by Serbia, Slovakia and Spain, therefore not included.
 * (Kosovo lacks of ISO code, too.)
 */
export enum Country {
	Afghanistan = "Afghanistan",
	Albania = "Albania",
	Algeria = "Algeria",
	Andorra = "Andorra",
	Angola = "Angola",
	AntiguaAndBarbuda = "AntiguaAndBarbuda",
	Argentina = "Argentina",
	Armenia = "Armenia",
	Australia = "Australia",
	Austria = "Austria",
	Azerbaijan = "Azerbaijan",
	Bahamas = "Bahamas",
	Bahrain = "Bahrain",
	Bangladesh = "Bangladesh",
	Barbados = "Barbados",
	Belarus = "Belarus",
	Belgium = "Belgium",
	Belize = "Belize",
	Benin = "Benin",
	Bhutan = "Bhutan",
	Bolivia = "Bolivia",
	BosniaAndHerzegovina = "BosniaAndHerzegovina",
	Botswana = "Botswana",
	Brazil = "Brazil",
	Brunei = "Brunei",
	Bulgaria = "Bulgaria",
	BurkinaFaso = "BurkinaFaso",
	Burundi = "Burundi",
	CaboVerde = "CaboVerde",
	Cambodia = "Cambodia",
	Cameroon = "Cameroon",
	Canada = "Canada",
	CentralAfricanRepublic = "CentralAfricanRepublic",
	Chad = "Chad",
	Chile = "Chile",
	China = "China",
	Colombia = "Colombia",
	Comoros = "Comoros",
	Congo = "Congo",
	CostaRica = "CostaRica",
	CoteDIvoire = "CoteDIvoire",
	Croatia = "Croatia",
	Cuba = "Cuba",
	Cyprus = "Cyprus",
	Czechia = "Czechia",
	DemocraticRepublicOfTheCongo = "DemocraticRepublicOfTheCongo",
	Denmark = "Denmark",
	Djibouti = "Djibouti",
	Dominica = "Dominica",
	DominicanRepublic = "DominicanRepublic",
	Ecuador = "Ecuador",
	Egypt = "Egypt",
	ElSalvador = "ElSalvador",
	EquatorialGuinea = "EquatorialGuinea",
	Eritrea = "Eritrea",
	Estonia = "Estonia",
	Eswatini = "Eswatini",
	Ethiopia = "Ethiopia",
	Fiji = "Fiji",
	Finland = "Finland",
	France = "France",
	Gabon = "Gabon",
	Gambia = "Gambia",
	Georgia = "Georgia",
	Germany = "Germany",
	Ghana = "Ghana",
	Greece = "Greece",
	Grenada = "Grenada",
	Guatemala = "Guatemala",
	Guinea = "Guinea",
	GuineaBissau = "GuineaBissau",
	Guyana = "Guyana",
	Haiti = "Haiti",
	Honduras = "Honduras",
	Hungary = "Hungary",
	Iceland = "Iceland",
	India = "India",
	Indonesia = "Indonesia",
	Iran = "Iran",
	Iraq = "Iraq",
	Ireland = "Ireland",
	Israel = "Israel",
	Italy = "Italy",
	Jamaica = "Jamaica",
	Japan = "Japan",
	Jordan = "Jordan",
	Kazakhstan = "Kazakhstan",
	Kenya = "Kenya",
	Kiribati = "Kiribati",
	Kuwait = "Kuwait",
	Kyrgyzstan = "Kyrgyzstan",
	Laos = "Laos",
	Latvia = "Latvia",
	Lebanon = "Lebanon",
	Lesotho = "Lesotho",
	Liberia = "Liberia",
	Libya = "Libya",
	Liechtenstein = "Liechtenstein",
	Lithuania = "Lithuania",
	Luxembourg = "Luxembourg",
	Madagascar = "Madagascar",
	Malawi = "Malawi",
	Malaysia = "Malaysia",
	Maldives = "Maldives",
	Mali = "Mali",
	Malta = "Malta",
	MarshallIslands = "MarshallIslands",
	Mauritania = "Mauritania",
	Mauritius = "Mauritius",
	Mexico = "Mexico",
	Micronesia = "Micronesia",
	Moldova = "Moldova",
	Monaco = "Monaco",
	Mongolia = "Mongolia",
	Montenegro = "Montenegro",
	Morocco = "Morocco",
	Mozambique = "Mozambique",
	Myanmar = "Myanmar",
	Namibia = "Namibia",
	Nauru = "Nauru",
	Nepal = "Nepal",
	Netherlands = "Netherlands",
	NewZealand = "NewZealand",
	Nicaragua = "Nicaragua",
	Niger = "Niger",
	Nigeria = "Nigeria",
	NorthKorea = "NorthKorea",
	NorthMacedonia = "NorthMacedonia",
	Norway = "Norway",
	Oman = "Oman",
	Pakistan = "Pakistan",
	Palau = "Palau",
	Panama = "Panama",
	PapuaNewGuinea = "PapuaNewGuinea",
	Paraguay = "Paraguay",
	Peru = "Peru",
	Philippines = "Philippines",
	Poland = "Poland",
	Portugal = "Portugal",
	Qatar = "Qatar",
	Romania = "Romania",
	Russia = "Russia",
	Rwanda = "Rwanda",
	SaintKittsAndNevis = "SaintKittsAndNevis",
	SaintLucia = "SaintLucia",
	SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines",
	Samoa = "Samoa",
	SanMarino = "SanMarino",
	SaoTomeAndPrincipe = "SaoTomeAndPrincipe",
	SaudiArabia = "SaudiArabia",
	Senegal = "Senegal",
	Serbia = "Serbia",
	Seychelles = "Seychelles",
	SierraLeone = "SierraLeone",
	Singapore = "Singapore",
	Slovakia = "Slovakia",
	Slovenia = "Slovenia",
	SolomonIslands = "SolomonIslands",
	Somalia = "Somalia",
	SouthAfrica = "SouthAfrica",
	SouthKorea = "SouthKorea",
	SouthSudan = "SouthSudan",
	Spain = "Spain",
	SriLanka = "SriLanka",
	Sudan = "Sudan",
	Suriname = "Suriname",
	Sweden = "Sweden",
	Switzerland = "Switzerland",
	Syria = "Syria",
	Taiwan = "Taiwan",
	Tajikistan = "Tajikistan",
	Tanzania = "Tanzania",
	Thailand = "Thailand",
	TimorLeste = "TimorLeste",
	Togo = "Togo",
	Tonga = "Tonga",
	TrinidadAndTobago = "TrinidadAndTobago",
	Tunisia = "Tunisia",
	Turkey = "Turkey",
	Turkmenistan = "Turkmenistan",
	Tuvalu = "Tuvalu",
	Uganda = "Uganda",
	Ukraine = "Ukraine",
	UnitedArabEmirates = "UnitedArabEmirates",
	UnitedKingdom = "UnitedKingdom",
	UnitedStates = "UnitedStates",
	Uruguay = "Uruguay",
	Uzbekistan = "Uzbekistan",
	Vanuatu = "Vanuatu",
	VaticanCity = "VaticanCity",
	Venezuela = "Venezuela",
	Vietnam = "Vietnam",
	Yemen = "Yemen",
	Zambia = "Zambia",
	Zimbabwe = "Zimbabwe",
}
